/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './BancoDoAuto25BannerAgo26.css';

function BancoDoAuto25BannerAgo26() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 599 && (
                  <img
                    src="assets/banco-do-auto25/hero-ago-26/img-280.png"
                    alt="Pessoa sentada no banco do motorista de um veículo, com o braço apoiado na janela, representando o financiamento de veículos e a conquista do carro próprio após uma simulação online na Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 599 && width <= 799 && (
                  <img
                    src="assets/banco-do-auto25/hero-ago-26/img-240.png"
                    alt="Pessoa sentada no banco do motorista de um veículo, com o braço apoiado na janela, representando o financiamento de veículos e a conquista do carro próprio após uma simulação online na Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 799 && width <= 1099 && (
                  <img
                    src="assets/banco-do-auto25/hero-ago-26/img-379.png"
                    alt="Pessoa sentada no banco do motorista de um veículo, com o braço apoiado na janela, representando o financiamento de veículos e a conquista do carro próprio após uma simulação online na Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 1099 && (
                  <img
                    src="assets/banco-do-auto25/hero-ago-26/img-558.png"
                    alt="Pessoa sentada no banco do motorista de um veículo, com o braço apoiado na janela, representando o financiamento de veículos e a conquista do carro próprio após uma simulação online na Santander Financiamentos."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
                <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
              </div> */}
            <div className="hero-texts">
              <h2 className="hero-title">O caminho para o seu próximo veículo começa aqui</h2>
              <h3 className="hero-sub-title">
                Simule agora e aproveite condições facilitadas e acessíveis para conquistar seu novo
                carro.
              </h3>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=banco-do-auto:banner&int_campaign=simular-financiamento"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Quero Simular
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default BancoDoAuto25BannerAgo26;
